module.exports = __webpack_public_path__ + "img/CECA_pDC.872e600a.png";